// @ts-nocheck
import {
  generateUniqueId,
  createField,
} from '../RegisterForm/CustomFormBuilder/config/constant';

export const resetForm = (state) => ({
  ...state,
  title: '',
  description: '',
  aiDescription: '',
  formFields: [],
  employeeRole: [],
  employeeData: [],
  userRole: [],
  userData: [],
  equipmentType: [],
  equipmentData: [],
  currentLocation: null,
  isStatusOnSubmission: null,
  isCollectGeolocation: false,
  isEditResponse: false,
  isProjectTimesheetRequired: false,
  isProjectClockInCompulsory: false,
  isEmployeeTimesheetRequired: false,
  isEmployeeClockInCompulsory: false,
  isEquipmentClockInCompulsory: false,
  activeTableField: {
    isEditingRow: false,
    tableId: null,
    isTableRequired: false,
    contentIndex: null,
    contents: [],
    headers: [],
    requiredColumnIndexes: [],
  },
});

export const updateTable = (state, action) => {
  const {
    payload: { fieldId, key, value },
  } = action;
  return {
    ...state,
    formFields: state.formFields.map((field) => {
      if (field.id !== fieldId) return field;

      return {
        ...field,
        [key]: value,
      };
    }),
  };
};

export const addColumn = (state, action) => {
  const {
    payload: { fieldId },
  } = action;
  return {
    ...state,
    formFields: state.formFields.map((field) => {
      if (field.id !== fieldId) return field;

      return {
        ...field,
        headers: [...field.headers, `Column ${field.headers.length + 1}`],
        contents: field.contents.map((row) => [
          ...row,
          createField('shorttext'),
        ]),
      };
    }),
  };
};

export const addColumnFromDrawer = (state, action) => {
  return {
    ...state,

    activeTableField: {
      ...state.activeTableField,
      contents: [...state.activeTableField.contents, createField('shorttext')],
      headers: [
        ...state.activeTableField.headers,
        `Column ${state.activeTableField.headers.length + 1}`,
      ],
    },
  };
};

const getRequiredColumnIndexes = (row = []) =>
  row.reduce(
    (acc, col, colIndex) => (col.isRequired ? acc.concat(colIndex) : acc),
    [],
  );

export const addRow = (state, action) => {
  const {
    payload: { fieldId },
  } = action;
  return {
    ...state,
    formFields: state.formFields.map((field) => {
      if (field.id !== fieldId) return field;

      const lastRowIndex = field.contents.length - 1;

      return {
        ...field,
        contents: [
          ...field.contents,
          field.contents[lastRowIndex].map((col) => ({
            ...col,
            id: generateUniqueId(),
          })),
        ],
      };
    }),
  };
};

export const deleteRow = (state, action) => {
  const {
    payload: { fieldId, rowIndex },
  } = action;
  return {
    ...state,
    formFields: state.formFields.map((field) => {
      if (field.id !== fieldId) return field;

      return {
        ...field,
        contents: field.contents.filter((_, rIndex) => rIndex !== rowIndex),
      };
    }),
  };
};

export const deleteColumn = (state, action) => {
  const {
    payload: { fieldId, columnIndex },
  } = action;
  return {
    ...state,
    formFields: state.formFields.map((field) => {
      if (field.id !== fieldId) return field;

      return {
        ...field,
        headers: field.headers.filter((_, index) => index !== columnIndex),
        contents: field.contents.map((row) =>
          row.filter((_, index) => index !== columnIndex),
        ),
      };
    }),
  };
};

export const duplicateColumn = (state, action) => {
  const {
    payload: { fieldId, columnIndex },
  } = action;
  return {
    ...state,
    formFields: state.formFields.map((field) => {
      if (field.id !== fieldId) return field;

      return {
        ...field,
        headers: [
          ...field.headers.slice(0, columnIndex),
          field.headers[columnIndex],
          ...field.headers.slice(columnIndex),
        ],
        contents: field.contents.map((row) => [
          ...row.slice(0, columnIndex),
          { ...row[columnIndex], id: generateUniqueId() },
          ...row.slice(columnIndex),
        ]),
      };
    }),
  };
};

export const duplicateRow = (state, action) => {
  const {
    payload: { fieldId, rowIndex },
  } = action;
  return {
    ...state,
    formFields: state.formFields.map((field) => {
      if (field.id !== fieldId) return field;

      return {
        ...field,
        contents: [
          ...field.contents,
          field.contents[rowIndex].map((col) => ({
            ...col,
            id: generateUniqueId(),
            answer: col.type === 'multisignature' ? [] : '',
            selectedLinkListLabel: '',
          })),
        ],
      };
    }),
  };
};

export const editTableRow = (state, action) => {
  const {
    payload: { contentIndex, fieldIndex },
  } = action;
  const rowForEdit = state.formFields[fieldIndex]?.contents[contentIndex];

  return {
    ...state,
    activeTableField: {
      contentIndex,
      isEditingRow: true,
      tableId: state.formFields[fieldIndex]?.id,
      isTableRequired: state.formFields[fieldIndex]?.isRequired,
      contents: rowForEdit ? rowForEdit.map((col) => ({ ...col })) : [],
      headers: [...state.formFields[fieldIndex].headers],
      requiredColumnIndexes: getRequiredColumnIndexes(rowForEdit),
    },
  };
};

export const editTableColumn = (state, action) => {
  const {
    payload: { contentIndex, fieldIndex },
  } = action;

  const columns = [];

  state.formFields[fieldIndex].contents.forEach((row) => {
    row.forEach((col, index) => {
      if (contentIndex === index) {
        columns.push({ ...col });
      }
    });
  });

  return {
    ...state,
    activeTableField: {
      headers: [...state.formFields[fieldIndex].headers],
      contentIndex,
      isEditingRow: false,
      tableId: state.formFields[fieldIndex]?.id,
      isTableRequired: state.formFields[fieldIndex]?.isRequired,
      contents: columns,
      requiredColumnIndexes: [],
    },
  };
};

export const editTableHeaders = (state, action) => {
  const {
    payload: { fieldIndex },
  } = action;

  return {
    ...state,
    activeTableField: {
      headers: [...state.formFields[fieldIndex].headers],
      contentIndex: -1,
      isEditingRow: false,
      tableId: state.formFields[fieldIndex]?.id,
      isTableRequired: state.formFields[fieldIndex]?.isRequired,
      contents: [],
      requiredColumnIndexes: [],
    },
  };
};

export const updateColumnType = (state, action) => {
  const {
    payload: { fieldType, contentIndex },
  } = action;
  const field = createField(fieldType);

  return {
    ...state,
    activeTableField: {
      ...state.activeTableField,
      contents: state.activeTableField.contents.map((col, ind) =>
        ind === contentIndex
          ? { ...field, id: col.id, isRequired: col.isRequired }
          : col,
      ),
    },
  };
};

const filterChoices = (rw) => {
  if (rw.choice) {
    rw.choice = rw.choice.filter((ch) => ch.label);
  }
  return rw;
};

const updateRowColumns = (row, requiredColumnIndexes) =>
  row.map((col, colIndex) => ({
    ...col,
    isRequired:
      col.type === 'instruction'
        ? false
        : requiredColumnIndexes.includes(colIndex),
  }));

const addNewColumnsToRow = (
  row,
  editedRowContent,
  numberOfColumnsToAdd,
  requiredColumnIndexes,
) => {
  const newRow = [
    ...row,
    ...editedRowContent.slice(-numberOfColumnsToAdd).map((col) => ({
      ...col,
      id: generateUniqueId(),
    })),
  ];

  return updateRowColumns(newRow, requiredColumnIndexes);
};

export const updateTableRow = (state) => {
  const editedRowContent = state.activeTableField.contents.map(filterChoices);

  return {
    ...state,

    formFields: state.formFields.map((field) => {
      if (field.id !== state.activeTableField.tableId) return field;

      return {
        ...field,
        headers: [...state.activeTableField.headers],

        contents: field.contents.map((row, index) => {
          const isEditedRow = index === state.activeTableField.contentIndex;

          if (isEditedRow) return editedRowContent;

          const isColumnAddedFromDrawer = editedRowContent.length > row.length;

          if (!isColumnAddedFromDrawer)
            return updateRowColumns(
              row,
              state.activeTableField.requiredColumnIndexes,
            );

          const numberOfColumnsToAdd = editedRowContent.length - row.length;

          return addNewColumnsToRow(
            row,
            editedRowContent,
            numberOfColumnsToAdd,
            state.activeTableField.requiredColumnIndexes,
          );
        }),
      };
    }),

    activeTableField: {
      isEditingRow: false,
      tableId: null,
      isTableRequired: false,
      contentIndex: -1,
      contents: [],
      headers: [],
      requiredColumnIndexes: [],
    },
  };
};

export const updateTableColumn = (state) => {
  return {
    ...state,
    formFields: state.formFields.map((field) => {
      if (field.id !== state.activeTableField.tableId) return field;

      return {
        ...field,

        contents: field.contents.map((row, rowIndex) => {
          return row.map((col, colIndex) => {
            if (colIndex === state.activeTableField.contentIndex) {
              return state.activeTableField.contents[rowIndex];
            }
            return col;
          });
        }),
      };
    }),
    activeTableField: {
      isEditingRow: false,
      tableId: null,
      isTableRequired: false,
      contentIndex: -1,
      contents: [],
      headers: [],
      requiredColumnIndexes: [],
    },
  };
};

export const updateTableHeaders = (state) => {
  return {
    ...state,
    formFields: state.formFields.map((field) => {
      if (field.id !== state.activeTableField.tableId) return field;

      return {
        ...field,
        headers: state.activeTableField.headers,
      };
    }),
    activeTableField: {
      isEditingRow: false,
      tableId: null,
      isTableRequired: false,
      contentIndex: -1,
      contents: [],
      headers: [],
      requiredColumnIndexes: [],
    },
  };
};

export const updateColumnHeader = (state, action) => {
  const {
    payload: { headerIndex, header },
  } = action;
  return {
    ...state,
    activeTableField: {
      ...state.activeTableField,
      headers: state.activeTableField.headers.map((h, ind) =>
        ind === headerIndex ? header : h,
      ),
    },
  };
};

export const updateColumn = (state, action) => {
  const {
    payload: { contentIndex, properties },
  } = action;

  return {
    ...state,
    activeTableField: {
      ...state.activeTableField,
      contents: state.activeTableField.contents.map((col, ind) =>
        ind === contentIndex ? { ...col, ...properties } : col,
      ),
    },
  };
};

export const updateColumnRequiredField = (state, action) => {
  const {
    payload: { contentIndex, isRequired },
  } = action;

  return {
    ...state,
    activeTableField: {
      ...state.activeTableField,
      contents: state.activeTableField.contents.map((col, ind) =>
        ind === contentIndex ? { ...col, isRequired } : col,
      ),
      requiredColumnIndexes:
        state.activeTableField.requiredColumnIndexes.includes(contentIndex)
          ? state.activeTableField.requiredColumnIndexes.filter(
              (colInd) => colInd !== contentIndex,
            )
          : state.activeTableField.requiredColumnIndexes.concat(contentIndex),
    },
  };
};

export const updateChoice = (state, action) => {
  const {
    payload: { contentIndex, choiceIndex, key, value },
  } = action;
  return {
    ...state,
    activeTableField: {
      ...state.activeTableField,
      contents: state.activeTableField.contents.map((col, ind) => {
        if (ind !== contentIndex) return col;
        return {
          ...col,
          choice: col.choice.map((choice, index) => {
            if (index === choiceIndex) {
              return { ...choice, [key]: value };
            }
            return choice;
          }),
        };
      }),
    },
  };
};

export const updateAnswer = (state, action) => {
  const {
    payload: { fieldId, rowIndex, colIndex, answer },
  } = action;
  return {
    ...state,
    formFields: state.formFields.map((field) => {
      if (field.id !== fieldId) return field;

      return {
        ...field,

        contents: field.contents.map((row, index) => {
          if (index != rowIndex) return row;
          return row.map((col, ind) => {
            if (ind != colIndex) return col;
            const updatedCol = { ...col, answer };
            return updatedCol;
          });
        }),
      };
    }),
  };
};

export const updatePreviewColumn = (state, action) => {
  const {
    payload: { fieldId, rowIndex, colIndex, properties },
  } = action;
  return {
    ...state,
    formFields: state.formFields.map((field) => {
      if (field.id !== fieldId) return field;

      return {
        ...field,

        contents: field.contents.map((row, index) => {
          if (index != rowIndex) return row;
          return row.map((col, ind) => {
            if (ind != colIndex) return col;
            const updatedCol = { ...col, ...properties };
            return updatedCol;
          });
        }),
      };
    }),
  };
};
export const reorderTableRow = (state, action) => {
  const {
    payload: { fieldIndex, rowSourceIndex, rowDestinationIndex },
  } = action;

  return {
    ...state,
    formFields: state.formFields.map((field, index) => {
      if (index !== fieldIndex) return field;

      const fieldContents = Array.from(field.contents);
      const [removed] = fieldContents.splice(rowSourceIndex, 1);
      fieldContents.splice(rowDestinationIndex, 0, removed);
      return {
        ...field,
        contents: fieldContents,
      };
    }),
  };
};

export const resizeTableColumn = (state, action) => {
  const {
    payload: { fieldIndex, columnIndex, columnWidth },
  } = action;

  return {
    ...state,
    formFields: state.formFields.map((field, index) => {
      if (index !== fieldIndex) return field;

      return {
        ...field,
        contents: field.contents.map((row) => {
          return row.map((col, colIndex) => {
            if (colIndex !== columnIndex) return col;

            return {
              ...col,
              width: columnWidth,
            };
          });
        }),
      };
    }),
  };
};

export const setTableIsRequired = (state, action) => {
  const {
    payload: { fieldId, isRequired },
  } = action;

  return {
    ...state,
    formFields: state.formFields.map((field) => {
      if (field.id !== fieldId) return field;

      if (isRequired) {
        return {
          ...field,
          isRequired,
        };
      }

      return {
        ...field,
        isRequired,
        contents: field.contents.map((row) => {
          return row.map((col, colIndex) => {
            return {
              ...col,
              isRequired,
            };
          });
        }),
      };
    }),
  };
};
